import { maskitoPhoneOptionsGenerator } from '@maskito/phone';

// This metadata was automatically generated by running 'npm run generate-libphonenumber-metadata --extended' in a dev environment.
// We can't use the metadata file provided by libphonenumber-js because Jest tests will fail for an unknown reason

const metadata = { 'version':4, 'country_calling_codes':{ '64':['NZ'] }, 'countries':{ 'NZ': [
    '64',
    '0(?:0|161)',
    '[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}',
    [5, 6, 7, 8, 9, 10],
    [
        [
            '(\\d{2})(\\d{3,8})',
            '$1 $2',
            ['8[1-79]'],
            '0$1'
        ],
        // The below rows are formatted as follows:
        // [<resulting format>, <capture groups>, [<regex matches>], <optional condition>]
        // resulting format: The format to apply to the number
        // capture groups: Variables to capture from the regex match, e.g. 021 123 4567 would have $1 = 021, $2 = 123, $3 = 4567
        // regex matches: The regex matches to apply this format to
        // optional condition: Apply the regex match if this condition is met as well (to allow e.g. +64 021 as well as +64 21)
        ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['50[036-8]|8|90', '50(?:[0367]|88)|8|90'], '0$1'],
        ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['24|[346]|7[2-57-9]|9[2-9]'], '0$1'],
        // We want 0274 and 0210 numbers to be '027 400 0000' not '0274 000 000'
        // ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2(?:10|74)|[589]'], '0$1'], -- the original pattern
        ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['2(?:10|74)'], '0$1'],
        ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[589]'], '0$1'],
        //
        ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1|2[028]'], '0$1'],
        // We want numbers with 8 digits after the prefix to be split into groups of 4 and 4 rather than 3 and 5,
        // since Lab Sys doesn't allow the last group to be longer than 4 digits
        // ['(\\d{2})(\\d{3})(\\d{3,5})', '$1 $2 $3', ['2(?:[169]|7[0-35-9])|7'], '0$1'], -- the original pattern
        ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2(?:[169]|7[0-35-9])|7'], '0$1'],
        ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['2(?:[169]|7[0-35-9])|7'], '0$1']
        //
    ],
    '0', 0, 0, 0, 0, 0,
    [
        [
            '24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}',
            [8]
        ],
        [
            '2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}',
            [8, 9, 10]
        ],
        ['508\\d{6,7}|80\\d{6,8}',
            [8, 9, 10]
        ],
        [
            '(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}',
            [7, 8, 9, 10]
        ],
        ['70\\d{7}', [9]],
        0,
        ['8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}']], '00'
] }, 'nonGeographic':{} };

export default maskitoPhoneOptionsGenerator({ countryIsoCode: 'NZ', separator: ' ', metadata: metadata as any });
